"use client";

import Container from "@/components/Container";
import Section from "@/components/Section";
import Text from "@/components/Text";
import GridCarousel from "./GridCarousel";
import { Swiper, SwiperSlide } from "swiper/react";
import { string } from "three/examples/jsm/nodes/Nodes.js";
import { transformText } from "@/utils/transformText";

type ImageType = {
  src: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  alt: string;
};

type ButtonType = {
  text: string;
  link: string;
};

type CarouselType = {
  image?: ImageType;
  title: string;
  text?: string;
  button?: ButtonType;
  additionalText?: string;
  tag?: string;
};

export type SingleItemType = {
  id: number;
  carousel: CarouselType[];
};

type ItemType = {
  id: number;
  layout: 2 | 3 | 4;
  item: SingleItemType[];
};

type ContentType = {
  title: string;
  items: ItemType[];
};

type GridImagesWithCarouselProps = {
  section: {
    type: string;
    content: ContentType;
  };
};

const GridImagesWithCarousel = ({ section }: GridImagesWithCarouselProps) => {
  const renderLayoutClass = (layout: 2 | 3 | 4) => {
    const layoutClasses = {
      2: "grid-images-with-carousel__main-carousel--two",
      3: "grid-images-with-carousel__main-carousel--three",
      4: "grid-images-with-carousel__main-carousel--four",
    };

    return layoutClasses[layout];
  };
  return (
    <Section className="bg-white grid-images-with-carousel" id="included">
      <Container>
        <Text
          element="h2"
          elementStyle="h1"
          className="darker-gold text-center center"
        >
          {transformText(section.content.title, {
            br: (chunk) => <br />,
          })}
        </Text>
        <div className="grid-images-with-carousel__holder">
          {section.content.items.map((item) => (
            <Swiper
              key={item.id}
              slidesPerView={1.2}
              spaceBetween={15}
              className={renderLayoutClass(item.layout)}
              breakpoints={{
                767: {
                  slidesPerView: 1.6,
                  spaceBetween: 30,
                },
                992: {
                  slidesPerView: item.layout > 2 ? 2 : item.layout,
                },
                1200: {
                  slidesPerView: item.layout > 2 ? 3 : item.layout,
                },
                1400: {
                  slidesPerView: item.layout,
                },
              }}
            >
              {item.item.map((card) => (
                <SwiperSlide key={card.id}>
                  <GridCarousel item={card} />
                </SwiperSlide>
              ))}
            </Swiper>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default GridImagesWithCarousel;
